import { SVCurrencyInput } from '@/components/core';
import { FORM_FIELDS } from '@/constants/formFields';
import { Card, Typography, Grid } from '@mui/material';

export default function InitialDepositSection() {
  return (
    <Card>
      <Typography variant="h5" mb={2}>
        Initial Deposit Minimum for New Bank Accounts
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <SVCurrencyInput
            name="minimumInitDeposit"
            {...FORM_FIELDS.MINIMUM_INIT_DEPOSIT}
          />
        </Grid>
      </Grid>
    </Card>
  );
}
